import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {environment} from "../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {DepositModel} from "./deposit.model";

@Injectable({
  providedIn: 'root'
})
export class DepositService {

  constructor(private http: HttpClient) { }

  public sendDeposit(request : DepositModel) : Observable<any>
  {
    return this.http.post<any>(`${environment.apiUrl}/deposit`,request);
  }
}
